import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  const [shopeDetails, setShopeDetails] = useState([]);

  useEffect(() => {
    fetch("/assets/carData/shopDetails.json")
      .then((res) => res.json())
      .then((data) => setShopeDetails(data))
      .catch((err) => console.error("Failed to fetch shop data", err));
  }, []);

  const shop = shopeDetails[0]; // safe shortcut

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1c1c1c',
        color: '#fff',
        py: 4,
        px: 2,
        mt: 4,
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        {/* Company Info */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" gutterBottom>
            True Choice Car's
          </Typography>
          {shop && (
            <Typography variant="body2">
              {shop.address}<br />
              Phone: {shop.phone}<br />
              Email: info@truechoicecars.com
            </Typography>
          )}
        </Grid>

        {/* Navigation Links */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" gutterBottom>
            Quick Links
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Link component={NavLink} to="/" color="inherit" underline="hover">Home</Link>
            <Link component={NavLink} to="/products" color="inherit" underline="hover">Products</Link>
            <Link component={NavLink} to="/contact" color="inherit" underline="hover">Contact Us</Link>
          </Box>
        </Grid>

        {/* Social Media Icons */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" gutterBottom>
            Follow Us
          </Typography>
          <Box>
            <IconButton href="https://www.facebook.com" target="_blank" sx={{ color: '#fff' }}>
              <FacebookIcon />
            </IconButton>
            <IconButton
              href={shop?.instagram || 'https://www.instagram.com'}
              target="_blank"
              sx={{ color: '#fff' }}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton href="https://www.linkedin.com" target="_blank" sx={{ color: '#fff' }}>
              <LinkedInIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      <Typography variant="body2" align="center" sx={{ mt: 4 }}>
        &copy; {new Date().getFullYear()} True Choice Car's. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
